import { Environment } from '@/resources/enums/environment'

export const isMswEnvironment = process.env.NODE_ENV === Environment.MSW

export const isDevelopmentEnvironment =
  process.env.NODE_ENV === Environment.DEVELOPMENT

export const isTestEnvironment = process.env.NODE_ENV === Environment.TEST

export const isLocalEnvironment =
  isDevelopmentEnvironment || isMswEnvironment || isTestEnvironment

export const isProductionEnvironment =
  process.env.ENV === Environment.PRODUCTION
